// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"293":"d2289cd7","962":"d2289cd7"}[chunkId] + ".chunk.css";
};